// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent,
  ScoreCard
}                         from '../../../components';


class PartnerFootball extends PureComponent {
  static propTypes = {
    earningGraphLabels:   PropTypes.array,
    revenueChart:  PropTypes.shape({
      headers: PropTypes.array,
      data: PropTypes.array
    }),
    earningGraphDatasets: PropTypes.array,
    teamMatesIsFetching:  PropTypes.bool,
    teamMates:            PropTypes.arrayOf(
      PropTypes.shape({
        picture:      PropTypes.string,
        firstname:    PropTypes.string,
        lastname:     PropTypes.string,
        profile:      PropTypes.string,
        profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
      })
    ),
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerFootball');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
      }
    } = this.props;

  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerFootball');
  }

  render() {
    const {
      statsTable,
      scoreCard
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
      }
    } = this.props;

    return(
      <div>

        <div className="row">
          <ScoreCard name="score_card_football_improve" data={scoreCard} reloadData={fetchScoreCardDataIfNeeded}/>
        </div>

      
        <div className="lead_flow">
          <div className="lead_header">
          <h4>Lead Flow</h4>
          </div>
         <div className="row hot_leads_pipeline">
         <div className="col-md-3">
          <StatsTable bigTable={true} name="response" game_type_id={2} displayName="Response" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="col-md-3">
           <StatsTable bigTable={true} name="contact_later" game_type_id={2} displayName="Contact Later" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="col-md-3">
           <StatsTable bigTable={true} name="demo" game_type_id={2} displayName="Demos" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="col-md-3">
           <StatsTable bigTable={true} name="verbal_confirmation" game_type_id={2} displayName="Verbal Confirmation" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          </div>
         </div> 

          <div className="lead_flow">
          <div className="lead_header">
          <h4>Renewals</h4>
          </div>
         <div className="row renewal_leads_pipeline">
         <div className="col-md-3">
          <StatsTable bigTable={true} name="renewal_list_upcoming" game_type_id={2} displayName="Upcoming" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="col-md-3">
           <StatsTable bigTable={true} name="renewal_list_overdue" game_type_id={2} displayName="Overdue" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="col-md-3">
           <StatsTable bigTable={true} name="renewal_list_dormant" game_type_id={2} displayName="Dormant/Inactive" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="col-md-3">
           <StatsTable bigTable={true} name="renewal_list_paused" game_type_id={2} displayName="Paused" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          </div>
         </div> 

          <div className="row">
          <StatsTable bigTable={true} name="customers_two_weeks_attendance" displayName="Absentee Report" game_type_id={2} data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>

         <div className="row">
          <StatsTable bigTable={true} name="active_customers" displayName="Active Customers" game_type_id={2} data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>

        <div className="row">
          <StatsTable bigTable={true} datefilter={true} name="batch_capacity_partner" displayName="Batch Capacity Summary" game_type_id={2} data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>

        <div className="row">
          <StatsTable name="lead_summary" game_type_id={2} displayName="Leads Summary" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div> 

      
        <div className="row">
          <StatsTable bigTable={true} name="batch_health" game_type_id={2} displayName="Batch Health" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>

       
         <div className="row">
          <StatsTable bigTable={true} name="all_customers" game_type_id={2} displayName="All Customers" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>

        <div className="row">
          <StatsTable bigTable={true} name="all_leads" game_type_id={2} displayName="All Leads" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
      </div>
    );
  }
}

export default PartnerFootball;



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerFootball/PartnerFootball.js